function checkAuthorized(response, router){

    if(response.response.status === 401){
       
        localStorage.removeItem("token")
        router.push("/Login").catch(() => { });
    }
}
export {checkAuthorized}